import React, { Component } from "react";
import getInputField from "../customFields/getInputField";
import SelectDropdown from "../FieldsComponents/SelectDropdown/SelectDropdown";
import { isMobile } from "react-device-detect";
import SimpleUnitList from "./StaticList/SimpleUniList";
import SimpleFormulaList from "./StaticList/SimpleFormulaList";
import CompositeList from "./StaticList/CompositeList";
import CompositeDropDownList from "./StaticList/CompositeDropDownList";
import CompositeFilterList from "./StaticList/CompositeFilterList";
import { IconSvg } from "reactackle-icons";
import getTableFields from "../../TableDefinitions/getTableFields";
import { Button } from "reactackle";

export default class Field extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: this.props.path,
        payload: {
          ...this.props.data
        },
        showForm: true,
        generatingStatement: false,
        statementLink: ""
      }
    };
  }

  itemHandler = (val, id, isPayload) => {
    //console.log(" id: " + id + " val:" + JSON.stringify(val));
    this.props.itemHandler(id, val, this.props.rowNum);
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      "createFields",
      this.props.data,
      this.itemHandler,
      disabled,
      this.props.ogTableDef
    );
  };

  getStaticList = (fieldName, disabled) => {
    return (
      <div>
        <hr />
        <SimpleUnitList
          stateChangeHandler={this.itemHandler}
          data={this.props.data.payload[fieldName]}
          title="LIST OF VALUES"
          stateFieldName={fieldName}
          fieldNameInArray={"name"}
          isPayload={true}
          emptyRow={{
            name: ""
          }}
          emptyTitle={"Add Value"}
        />
        <hr />
      </div>
    );
  };

  getFormulaList = (fieldName, disabled) => {
    return (
      <div>
        <hr />
        <SimpleFormulaList
          stateChangeHandler={this.itemHandler}
          data={this.props.data.payload[fieldName]}
          title="RULES"
          stateFieldName={fieldName}
          fieldNameInArray={"name"}
          isPayload={true}
          emptyRow={{
            name: ""
          }}
          emptyTitle={"Add Rule"}
        />
        <hr />
      </div>
    );
  };

  getCompositeList = (fieldName, disabled) => {
    return (
      <CompositeList
        stateChangeHandler={this.itemHandler}
        data={this.props.data.payload[fieldName]}
        title="FIELDS IN GRID"
        stateFieldName={fieldName}
        isPayload={true}
        emptyRow={{
          name: "",
          key: "",
          editable: true,
          resizable: true
        }}
      />
    );
  };

  getCompositeDropDownList = (fieldName, title, emptyTitle, disabled) => {
    return (
      <CompositeDropDownList
        stateChangeHandler={this.itemHandler}
        data={this.props.data.payload[fieldName]}
        title={title}
        emptyTitle={emptyTitle}
        stateFieldName={fieldName}
        isPayload={true}
        emptyRow={{
          src: "",
          tgt: ""
        }}
        srcTableFields={() =>
          this.getListOfFields(this.props.data.payload.table)
        }
        tgtTableFields={this.props.tgtFieldsList}
      />
    );
  };

  getCompositeFilterList = (fieldName, title, emptyTitle, disabled) => {
    return (
      <CompositeFilterList
        stateChangeHandler={this.itemHandler}
        data={this.props.data.payload[fieldName]}
        title={title}
        emptyTitle={emptyTitle}
        stateFieldName={fieldName}
        isPayload={true}
        emptyRow={{
          src: "",
          tgt: ""
        }}
        srcTableFields={() =>
          this.getListOfFields(this.props.data.payload.table)
        }
        tgtTableFields={this.props.tgtFieldsList}
      />
    );
  };

  getTableList = (fieldName, isDisabled) => {
    return (
      <SelectDropdown
        title={"SOURCE TABLE"}
        data={this.props.tableList}
        label={"SOURCE TABLE"}
        placeholder={"SOURCE TABLE"}
        value={this.props.data.payload[fieldName]}
        stateFieldName={fieldName}
        isPayload={true}
        fieldName={"name"}
        stateHandler={this.itemHandler}
      />
    );
  };

  getListOfGrids = () => {
    let listOfFields = this.props.tgtFieldsList("name");
    if (listOfFields && listOfFields.length > 0) {
      return listOfFields.filter(item => item.fldType === "array");
    } else {
      return [];
    }
  };

  getSubGridsList = (fieldName, isDisabled) => {
    return (
      <SelectDropdown
        title={"SUB GRID NAME"}
        data={this.getListOfGrids()}
        label={"SUB GRID NAME"}
        placeholder={""}
        value={this.props.data.payload[fieldName]}
        stateFieldName={fieldName}
        isPayload={true}
        fieldName={"name"}
        stateHandler={this.itemHandler}
      />
    );
  };

  getSelectedSubGridsFields = (fieldName, selectedGrid) => {
    return (
      <SelectDropdown
        title={"SUB GRID FIELD"}
        data={this.props.selectedGridFields(selectedGrid)}
        label={"SUB GRID FIELD"}
        placeholder={""}
        value={this.props.data.payload[fieldName]}
        stateFieldName={fieldName}
        isPayload={true}
        fieldName={"name"}
        stateHandler={this.itemHandler}
      />
    );
  };

  getListOfFields = tgtTable => {
    //console.log(JSON.stringify(this.props.data));
    //console.log(JSON.stringify(this.state.data.payload));
    if (tgtTable) {
      //console.log("checking now...");
      return getTableFields(this.props.createTableList, tgtTable);
    }
  };

  getTableFieldsList = (fieldName, isDisabled) => {
    return (
      <SelectDropdown
        title={"SOURCE FIELD"}
        data={this.getListOfFields(this.props.data.payload.table)}
        label={"SOURCE FIELD"}
        placeholder={"SOURCE FIELD"}
        value={this.props.data.payload[fieldName]}
        stateFieldName={fieldName}
        isPayload={true}
        fieldName={"fieldName"}
        stateHandler={this.itemHandler}
      />
    );
  };

  getTriggerFieldList = (fieldName, isDisabled) => {
    return (
      <SelectDropdown
        title={"TRIGGER FIELD"}
        data={this.props.tgtFieldsList("name")}
        label={"TRIGGER FIELD"}
        placeholder={"TRIGGER FIELD"}
        value={this.props.data.payload[fieldName]}
        stateFieldName={fieldName}
        isPayload={true}
        fieldName={"fieldName"}
        stateHandler={this.itemHandler}
      />
    );
  };

  getDelIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.props.itemDeleteHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getUpIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.props.move(rowNum, rowNum - 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };
  getDownIcon = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.props.move(rowNum, rowNum + 1);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getAddStaticField = rowNum => {
    return (
      <div
        className="col-sm-2"
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          onClick={() => {
            this.props.move(rowNum, rowNum + 1);
          }}
        >
          <div>Add to List of Values</div>
        </a>
      </div>
    );
  };

  getPlusIcon = rowNum => {
    return (
      <div
        style={{
          padding: "10px",
          textAlign: "center",
          border: "1px solid gainsboro",
          height: "45px",
          width: "45px"
        }}
      >
        <a
          href="_"
          onClick={event => {
            event.preventDefault();
            this.props.itemAddHandler(rowNum);
          }}
        >
          <IconSvg>
            <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
              />
            </svg>
          </IconSvg>
        </a>
      </div>
    );
  };

  getExpandIcon = rowNum => {
    return (
      <Button
        text={"EXPAND"}
        onPress={() => {
          event.preventDefault();
          this.props.itemHandler("expanded", true, rowNum);
        }}
        colorScheme="primary"
        outlined
      />
    );
  };

  getCollapseIcon = rowNum => {
    return (
      <Button
        text={"COLLAPSE"}
        onPress={() => {
          event.preventDefault();
          this.props.itemHandler("expanded", false, rowNum);
        }}
        colorScheme="primary"
        outlined
      />
    );
  };

  getActionRow = () => {
    return (
      <div
        style={{
          backgroundColor: "gainsboro",
          borderBottom: "1px solid white"
        }}
      >
        <table>
          <tr>
            <td style={{ width: "45px" }}>
              {this.getDelIcon(this.props.rowNum)}
            </td>
            <td style={{ width: "45px" }}>
              {this.getUpIcon(this.props.rowNum)}
            </td>
            <td style={{ width: "45px" }}>
              {this.getDownIcon(this.props.rowNum)}
            </td>
            <td style={{ width: "45px" }}>
              {this.getPlusIcon(this.props.rowNum)}
            </td>

            {!this.props.data.payload.expanded && (
              <td>{this.getExpandIcon(this.props.rowNum)}</td>
            )}

            {this.props.data.payload.expanded && (
              <td>{this.getCollapseIcon(this.props.rowNum)}</td>
            )}

            <td>
              <div
                style={{
                  lineHeight: "30px",
                  minWidth: "150px",
                  border: "1px solid white",
                  margin: "2px",
                  paddingLeft: "5px",
                  paddingRight: "5px"
                }}
              >
                {this.props.data.payload.caption}
              </div>
            </td>

            <td>
              <div
                style={{
                  lineHeight: "30px",
                  minWidth: "150px",
                  border: "1px solid white",
                  margin: "2px",
                  paddingLeft: "5px",
                  paddingRight: "5px"
                }}
              >
                {this.props.data.payload.name}
              </div>
            </td>

            <td>
              <div
                style={{
                  lineHeight: "30px",
                  minWidth: "150px",
                  border: "1px solid white",
                  margin: "2px",
                  paddingLeft: "5px",
                  paddingRight: "5px"
                }}
              >
                {this.props.data.payload.type}
              </div>
            </td>

            {/* {this.props.data &&
              this.props.data.payload.expanded &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "static" &&
              this.props.data.payload["type"] === "search" && (
                <td>{this.getAddArrayField(this.props.rowNum)}</td>
              )} */}
          </tr>
        </table>
      </div>
    );
  };

  getCreateFieldForm = () => {
    return (
      <div>
        {this.getActionRow()}
        {this.props.data.payload.expanded && (
          <div>
            {this.getField("type", false)}
            {this.getField("name", false)}
            {this.getField("caption", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "input" &&
              this.getField("placeholder", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "textarea" &&
              this.getField("placeholder", false)}
            {this.getField("enabled", false)}
            {this.getField("isMust", false)}
            {this.getField("isHidden", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "input" &&
              this.getField("isSecure", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "input" &&
              this.getField("inputValidator", false)}

            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] !== "calculation" &&
              this.getField("defaultValue", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "textarea" &&
              this.getField("numOfLines", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calendar" &&
              this.getField("dateFormat", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calendar" &&
              this.getField("dateFormatOut", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calendar" &&
              this.getField("dateMaxDetail", false)}

            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "search" &&
              this.getField("selectorType", false)}
            {this.props.data &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "static" &&
              this.props.data.payload["type"] === "search" &&
              this.getStaticList("staticSource", false)}

            {this.props.data &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "table" &&
              this.props.data.payload["type"] === "search" &&
              this.getTableList("table", false)}
            {this.props.data &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "table" &&
              this.props.data.payload["type"] === "search" &&
              this.getTableFieldsList("tableField", false)}
            {this.props.data &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "table" &&
              this.props.data.payload["type"] === "search" &&
              this.getCompositeDropDownList(
                "otherFieldsToUpdate",
                "AUTO UPDATE FIELDS",
                "ADD AUTO UPDATE FIELDS",
                false
              )}
            {this.props.data &&
              this.props.data.payload["selectorType"] &&
              this.props.data.payload["selectorType"] === "table" &&
              this.props.data.payload["type"] === "search" &&
              this.getCompositeFilterList(
                "filters",
                "FILTER FIELDS",
                "ADD FILTER",
                false
              )}

            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "array" &&
              this.getCompositeList("colDefs", false)}

            {/* 
              calc block when field is subField operation 
              type=calculation
              triggerField=

              calcType=subFieldSum
              subGridName= ***
              subGridField= ***
              subFieldOperation= ***

              calcType=mainFieldCalc
              formula=

            */}

            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.getField("calcType", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.getTriggerFieldList("triggerField", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.props.data.payload["calcType"] === "subFieldsSum" &&
              this.getSubGridsList("subGridName", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.props.data.payload["calcType"] === "subFieldsSum" &&
              this.getSelectedSubGridsFields(
                "subGridField",
                this.props.data.payload.subGridName
              )}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.props.data.payload["calcType"] === "subFieldsSum" &&
              this.getField("subFieldOperation", false)}
            {this.props.data &&
              this.props.data.payload["type"] &&
              this.props.data.payload["type"] === "calculation" &&
              this.props.data.payload["calcType"] === "mainFieldCalc" &&
              this.getFormulaList("formula", false)}
          </div>
        )}
      </div>
    );
  };

  render() {
    return (
      <div>
        {isMobile && <div>{this.getCreateFieldForm()}</div>}
        <div
          style={{
            border: "0px solid black"
          }}
        >
          {!isMobile && this.getCreateFieldForm()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Screens/ControlEngine/Feild.jsx